export default __webpack_public_path__ + "static/media/finance_img.73c81139.svg";